import React from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import { getPhotoUrlWithFallback, useParticipants } from '@talkjs/react-components';
import { Colors } from '../../../assets/theme/Colors';
import { renderUserRoleChip } from '../../../helpers/chat';

const CustomConversationListItem = ({ conversation, common, isSelected }) => {
  const participants = useParticipants(conversation.id, 30);
  const firstParticipant = participants.find((p) => p?.user?.id === conversation.custom.createdBy)?.user;
  const firstParticipantRoles = firstParticipant?.custom?.roles ? JSON.parse(firstParticipant?.custom?.roles) : [];
  const firstParticipantTitles = firstParticipant?.custom?.titles ? JSON.parse(firstParticipant?.custom?.titles) : [];
  const { lastMessage, isUnread } = conversation;
  const { theme, conversationList } = common;
  const { TimeAgo } = theme;
  const isGroupChat = participants.length >= 3;
  const senderName = lastMessage?.sender?.name;
  const timestamp = lastMessage?.editedAt ?? lastMessage?.createdAt;

  if (!participants.length) {
    return null;
  }

  return (
    <Box
      className={isSelected ? 'selected' : ''}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        py: 1,
        px: 2,
        cursor: 'pointer',
        bgcolor: isSelected ? Colors.chat.selected : isUnread ? '#fbf6f6' : 'transparent',
        '&:hover': { bgcolor: '#fbf9f6' },
        '&.selected': {
          color: 'confirm.main',
          position: 'relative',
          '&:before': {
            content: '""',
            position: 'absolute',
            left: -3,
            top: 0,
            height: '100%',
            borderLeft: '6px solid',
            borderColor: 'confirm.main',
          },
        },
      }}
    >
      <Box sx={{ bgcolor: isUnread ? Colors.chat.unread : '', p: 0.5, borderRadius: '50%' }} />
      <Avatar
        sx={{ width: 40, height: 40 }}
        alt={firstParticipant?.name}
        src={firstParticipant ? getPhotoUrlWithFallback(firstParticipant) : 'no-picture'}
      />
      <Box
        sx={{ flex: 1, minWidth: 0 }}
        onClick={() => {
          conversationList.selectConversation(conversation.id);
        }}
      >
        <Box sx={{ display: 'flex', direction: 'row', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Typography
            variant="subtitle2"
            color="text.primary"
            sx={{ fontWeight: isUnread ? 700 : 500, lineHeight: 0.8 }}
          >
            {firstParticipant?.name}
          </Typography>
          {Array.isArray(firstParticipantRoles) && firstParticipantRoles.map((role) => renderUserRoleChip(role))}
        </Box>
        {Array.isArray(firstParticipantTitles) && (
          <Typography variant="caption" color="text.secondary" noWrap>
            {firstParticipantTitles.join(', ')}
          </Typography>
        )}
        <Typography variant="body2" color="text.secondary" noWrap sx={{ fontWeight: isUnread ? 700 : 500 }}>
          {isGroupChat && `${senderName}: `} {lastMessage?.plaintext}
        </Typography>
      </Box>
      <Box color="text.primary">
        <TimeAgo timestamp={timestamp} common={common} />
      </Box>
    </Box>
  );
};

export default CustomConversationListItem;
